export const blockIconsFileFolderShared = (
	<span className='material-symbols-outlined'>folder_shared</span>
);
